<template>
  <portal-modal
    size-class="!w-2/3 md:!w-2/5"
    footer-class="!p-0"
    elevated
  >
    <template #header>
      <div class="flex">
        <div class="items-center justify-center">
          <div class="bg-red-100 rounded-full w-10 h-10 items-center justify-center flex">
            <ion-icon
              name="warning-outline"
              class="text-red-500 w-6 h-6 mb-0.5"
            ></ion-icon>
          </div>
        </div>
        <div class="font-bold flex items-center pl-2">{{ title }}</div>
      </div>
    </template>
    <template #body>
      <div class="p-4 md:px-5 text-md">
        {{ text }}
      </div>
    </template>
    <template #footer>
      <div class="flex items-center justify-end w-full p-4 md:px-5 rounded-b-lg">
        <portal-button
          color="white"
          @click.prevent="$emit('dismiss')"
          >{{ cancel }}</portal-button
        >
        <portal-button
          color="red"
          class="ml-1"
          @click.prevent="$emit('confirm')"
        >
          {{ ok }}</portal-button
        >
      </div>
    </template>
  </portal-modal>
</template>
<script>
import PortalModal from "../UI/PortalModal.vue"
import PortalButton from "../UI/PortalButtons/PortalButton.vue"

export default {
  name: "PortalConfirmationAlert",
  components: { PortalModal, PortalButton },

  emits: ["dismiss", "confirm"],

  props: {
    text: { required: true, type: String },
    ok: { required: false, type: String, default: "DISMISS" },
    cancel: { required: false, type: String, default: "cancel" },
    title: { required: false, type: String, default: "Alert" },
  },
}
</script>
